import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsItForSection() {
  return <section className="py-20 bg-slate-50" data-id="element-119">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-heading font-bold text-slate-900" data-id="element-122">
            ¿Para quién es Emprende Digital?
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-123">
          {/* Es para */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border-t-8 border-brand-green" data-id="element-124">
            <h3 className="text-2xl font-heading font-bold text-slate-900 mb-6 flex items-center" data-id="element-125">
              Este programa es ideal para:
            </h3>
            <ul className="space-y-5" data-id="element-126">
              {['Personas que quieren independizarse económicamente', 'Profesionales que quieren monetizar su conocimiento', 'Emprendedores que quieren llevar su negocio a internet', 'Personas que quieren generar ingresos extra desde su hogar'].map((item, index) => <li key={index} className="flex items-start" data-id="element-127">
                  <CheckCircleIcon className="w-6 h-6 text-brand-green mr-3 flex-shrink-0 mt-0.5" data-id="element-128" />
                  <span className="text-lg text-slate-700" data-id="element-129">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO es para */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border-t-8 border-red-500" data-id="element-130">
            <h3 className="text-2xl font-heading font-bold text-slate-900 mb-6 flex items-center" data-id="element-131">
              ¿Para quién NO es?
            </h3>
            <p className="text-slate-600 mb-6" data-id="element-132">Este programa NO es para:</p>
            <ul className="space-y-5" data-id="element-133">
              {['Personas que buscan dinero fácil sin trabajar', 'Quienes no están dispuestos a aprender cosas nuevas', 'Quienes esperan resultados sin aplicar lo aprendido'].map((item, index) => <li key={index} className="flex items-start" data-id="element-134">
                  <XCircleIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-135" />
                  <span className="text-lg text-slate-700" data-id="element-136">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}